import { jsx as t } from "react/jsx-runtime";
import { forwardRef as x } from "react";
import { B as l } from "./BaseCheckbox-BGkrjof6.mjs";
const p = x(
  ({ className: r = "", id: o, lightBackground: e, hasError: s, style: a, children: m, ...c }, b) => /* @__PURE__ */ t(
    l,
    {
      style: a,
      id: o,
      ref: b,
      containerClassName: `rds-form-group-box ${r} ${s ? "rds-form-group-box--error" : ""}`,
      inputClassName: `rds-checkbox rds-checkbox__input ${e ? "rds-light" : ""}`,
      labelClassName: "rds-checkbox__label",
      ...c,
      children: m
    }
  )
);
p.displayName = "Checkbox";
export {
  p as C
};
